import React, {useEffect, useState} from 'react';
import {CardCvcElement, CardExpiryElement, CardNumberElement, useStripe, useElements} from '@stripe/react-stripe-js';
import {Button, Form} from "semantic-ui-react";
import {PaymentDetailsContext} from "./PaymentDetailsContainer";
import StripeField from "./stripeField";
import CreditCardErrors from "./creditCardErrors";

const CheckoutForm = (props) => {
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(true);
    const strings = props.strings;

    const stripe = useStripe();
    const elements = useElements();

    const {
        hideCreditCardPm,
        setCreditCardPm,
    } = PaymentDetailsContext.useContainer();

    useEffect(() => {
        setProcessing(!stripe);
    }, [stripe]);

    const handleSubmit = (ev) => {
        ev.preventDefault()
        setProcessing(true);
        setError(null);
        stripe?.createPaymentMethod({type: 'card', card: elements.getElement(CardNumberElement)})
            .then((result) => {
                setProcessing(false)
                if (result.error) {
                    setError(result.error);
                    console.log(result.error);
                } else {
                    setError(null);
                    setCreditCardPm(result.paymentMethod);
                    hideCreditCardPm();
                }
            });
    };

    return (
        <Form onSubmit={handleSubmit}>
            <CreditCardErrors errors={[error]} />
            <StripeField label={strings.paymentRequired.creditCard} component={CardNumberElement}/>
            <Form.Group widths="equal" style={{alignItems: "end"}}>
                <StripeField label={strings.paymentRequired.expiration} component={CardExpiryElement}/>
                <StripeField label={strings.paymentRequired.cvc} component={CardCvcElement}/>
            </Form.Group>
            <Button style={{marginRight: "1rem"}} primary basic onClick={hideCreditCardPm}>{strings.paymentRequired.cancel}</Button>
            <Button primary type="submit" disabled={processing}>{strings.paymentRequired.addCreditCard}</Button>
        </Form>
    );
}

export default CheckoutForm;